export default __webpack_public_path__ + "static/media/bl13.eae55f18.png";